import React from 'react';
import { Col, Row } from 'antd';
import { I18n } from '@aws-amplify/core';
import { useTheme } from 'styled-components';

import { ConsolidateIcon, DownloadIcon } from '@/assets/icons/v2';

import { ActionButton } from './styles';

const ACTIONS_GUTTER = 16;

interface FooterProps {
	readOnly?: boolean;
	consolidated: boolean;
	consolidating: boolean;
	downloading: boolean;
	onToggleConsolidate: () => void;
	onDownload: () => void;
}

export function Footer({
	readOnly = false,
	consolidated,
	consolidating,
	downloading,
	onToggleConsolidate,
	onDownload
}: Readonly<FooterProps>): JSX.Element {
	const theme = useTheme();

	let consolidateLabel = I18n.get('Consolidate analysis');
	let consolidateTone = theme.palette.risk.low.default;

	if (consolidated) {
		consolidateLabel = I18n.get('Deconsolidate');
		consolidateTone = theme.palette.risk.high.default;
	}

	const hasWriteActions = !readOnly;

	return (
		<Row justify="end" gutter={[ACTIONS_GUTTER, 0]}>
			{hasWriteActions && (
				<Col>
					<ActionButton
						$tone={consolidateTone}
						icon={<ConsolidateIcon />}
						loading={consolidating}
						onClick={onToggleConsolidate}
					>
						{consolidateLabel}
					</ActionButton>
				</Col>
			)}
			<Col>
				<ActionButton
					$tone={theme.palette.primary[600]}
					icon={<DownloadIcon />}
					loading={downloading}
					onClick={onDownload}
				>
					{I18n.get('Download PDF')}
				</ActionButton>
			</Col>
		</Row>
	);
}
